import { useCreateCompany } from "Company/Api/Mutation/createCompanyMutation";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { CompanyForm } from "../Form/Form";

export const CreateFormWidget = () => {
	const { mutate: createCompany, isPending } = useCreateCompany();
	const { t } = useResource();
	const companyResource = Resources.base.company;

	return (
		<BaseCard title={t(companyResource.shared.addNewCompany)}>
			<CompanyForm onSubmit={createCompany} isPending={isPending} />
		</BaseCard>
	);
};
